import {
    createRouter,
    createWebHashHistory
} from 'vue-router'
import Layout from '@/views/Layout.vue'
import Home from '@/views/Home/Home.vue'

const Login = () => import('@/views/Login.vue')
const Category = () => import('@/views/Category/Category.vue')
const Patent = () => import('@/views/Patent/Patent.vue')
const Sales = () => import('@/views/Patent/Sales.vue')
const Requirement = () => import('@/views/Patent/Requirement.vue')
const Team = () => import('@/views/Patent/Team.vue')
const Library = () => import('@/views/Patent/Library.vue')
const Download = () => import('@/views/Patent/Download.vue')
const About = () => import('@/views/Patent/About.vue')
const Contact = () => import('@/views/Patent/Contact.vue')
const News = () => import('@/views/Patent/News.vue')


const PatentDetail = () => import('@/views/Detail/PatentDetail.vue')
const SalesDetail = () => import('@/views/Detail/SalesDetail.vue')
const RequirementDetail = () => import('@/views/Detail/RequirementDetail.vue')
const TeamDetail = () => import('@/views/Detail/TeamDetail.vue')
const ExpertDetail = () => import('@/views/Detail/ExpertDetail.vue')
const NewsDetail = () => import('@/views/Detail/NewsDetail.vue')

const UserIndex = () => import('@/views/CmsUser/UserIndex.vue')



const routes = [{
    path: '/',
    name: 'Layout',
    component: Layout,
    children: [
        {
            path: '/',
            component: Home
        }, {
            path: '/category/:id',
            component: Category
        }, {
            path: '/patent',
            component: Patent
        }, {
            path: '/sales',
            component: Sales
        }, {
            path: '/requirement',
            component: Requirement
        }, {
            path: '/team',
            component: Team
        }, {
            path: '/library',
            component: Library
        }, {
            path: '/download',
            component: Download
        }, {
            path: '/about',
            component: About
        }, {
            path: '/contact',
            component: Contact
        }, {
            path: '/news',
            component: News
        }, {
            path: '/newsDetail/:id',
            component: NewsDetail
        }, {
            path: '/patentDetail/:id',
            component: PatentDetail
        }, {
            path: '/salesDetail/:id',
            component: SalesDetail
        }, {
            path: '/requirementDetail/:id',
            component: RequirementDetail
        }, {
            path: '/teamDetail/:id',
            component: TeamDetail
        }, {
            path: '/expertDetail/:expertName',
            component: ExpertDetail
        }, {
            path: '/userIndex',
            component: UserIndex
        }

    ]
}, {
    path: '/login',
    component: Login
}

]

const router = createRouter({
    // Hash模式
    history: createWebHashHistory(),
    routes
})

export default router